<template>
  <div class="image-gallery">
    <div class="image-container">
      <div v-for="(item, index) in imageList" :key="index" class="image-item">
        <el-image
          :src="item.url"
          :preview-src-list="previewList"
          fit="contain"
          class="image-content"
          :initial-index="index"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="image-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PictureDisplay",
  props: {
    // 图片列表，格式为 [{url: '图片地址', name: '图片名称'}]
    imageList: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    // 提取所有图片URL用于预览
    previewList() {
      return this.imageList.map((item) => item.url);
    },
  },
};
</script>

<style scoped>
.image-gallery {
  width: 100%;
  height: 100%;
  margin: 20px 0 0 0;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  overflow-y: auto;
  height: 580px;
  max-height: 580px;
  padding: 10px;
}

.image-item {
  width: 250px;
  cursor: pointer;
  transition: transform 0.3s;
}

.image-item:hover {
  transform: scale(1.05);
}

.image-content {
  width: 100%;
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.image-name {
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #606266;
  word-break: break-word;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
</style>